import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PartnerAnalysisGroup1 extends BaseEntity{

    partnerAnalysisGroup1Code : string;
    name                      : string;
    rank                      : number;
    
}

